<template>
  <Modal
    v-model="state"
    title="赠款消耗重算"
    width="443"
    class-name="c-modal vertical-center-modal"
    :mask-closable="false"
    :closable="false"
  >
    <div class="c-form">
      <Form :label-width="130">
        <FormItem label="重算月份">
          <el-select
            v-model="month"
            placeholder="请选择"
            collapse-tags
            filterable
            clearable
            :popper-append-to-body="false"
            style="overflow: hidden"
            class="calc-height"
          >
            <el-option v-for="item in months" :key="item" :value="item" :label="item" class="calc-height"></el-option>
          </el-select>
        </FormItem>
        <FormItem>
          <span style="color: #ff6400">重算开始后关闭窗口，不会取消重算</span>
        </FormItem>
      </Form>
    </div>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="closeModal">关闭</Button>
        <Button type="primary" :loading="loading" @click="reCalc">
          <span v-if="loading">重算中...</span>
          <span v-else>重算</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { updateAmountByMonth } from '@/api/track.plan.model'

export default {
  name: 'amountReCalc',
  props: {
    value: {
      type: Boolean
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    reCalc() {
      if (!this.month) {
        this.$Message.warning('请选择月份！')
        return
      }
      this.loading = true
      updateAmountByMonth({ reportMonth: this.month }).then((data) => {
        this.loading = false
        if (data && this.value) {
          this.$Message.success('重算完成')
          this.closeModal()
          this.$emit('on-refresh')
        }
      })
    },
    closeModal() {
      this.$emit('input', false)
    }
  },
  data() {
    return {
      month: '',
      months: [],
      loading: false
    }
  },
  created() {
    const date = new Date()
    const currYear = date.getFullYear()
    const currMonth = date.getMonth() + 1
    // 组装半年时间的重算月份展示
    for (let idx = 0; idx < 6; idx++) {
      let month = currMonth - idx
      let year = currYear
      if (month <= 0) {
        year = year - 1
        month = month + 12
      }
      this.months.push(`${year}-${month < 10 ? `0${month}` : month}`)
    }
    this.month = this.months[0]
  }
}
</script>

<style lang="scss" scoped>
.c-form {
  width: 100%;
  flex: auto;
  display: flex;
  justify-content: left;
  margin-bottom: 8px;

  ::v-deep .ivu-form-item {
    margin-bottom: 0;
    text-align: left;
    height: 32px;
  }

  ::v-deep .el-input__inner {
    height: 24px !important;
    line-height: 24px !important;
  }
}
</style>
